
import { Component, Prop, Vue } from 'vue-property-decorator';
import { FilterPreset } from '@/types';
import ConfirmDialog from '@/components/ConfirmDialog.vue';

@Component({
  components: {
    ConfirmDialog,
  },
})
export default class LoadFilterPresetMenu extends Vue {
  @Prop({ required: true })
  presets!: FilterPreset<any>[];

  menuOpen = false;

  confirmDialog = false;
  confirmOptions = {
    title: 'Elimina Preset',
    text: '',
    question: 'Questa azione non può essere annullata.',
    yesText: 'Elimina',
    noText: 'Annulla',
  };
  presetToDelete: FilterPreset<any> | null = null;

  onLoadPreset(preset: FilterPreset<any>) {
    // Chiudi il menu immediatamente
    this.menuOpen = false;

    // Emetti l'evento dopo un delay per permettere al menu di chiudersi visivamente
    setTimeout(() => {
      this.$emit('load', { name: preset.name, filters: preset.filters });
    }, 150);
  }

  onDeletePreset(preset: FilterPreset<any>) {
    this.presetToDelete = preset;
    this.confirmOptions.text = `Sei sicuro di voler eliminare il preset "${preset.name}"?`;
    this.confirmDialog = true;
  }

  async onConfirmDelete() {
    if (!this.presetToDelete) return;

    this.confirmDialog = false;
    this.menuOpen = false;

    // Emetti evento di eliminazione
    this.$emit('delete', { name: this.presetToDelete.name });

    this.presetToDelete = null;
  }
}
